
import Vue from 'vue'
import {Action, Getter} from 'vuex-class'
import {
  AUTH_LOG_USER_OUT, DELETE_BOARDER, DELETE_CONFIRMATION,
  FETCH_ACCOUNT_EMAILS, FETCH_ACCOUNT_USER, SET_IS_DELETE_CONFIRMATION,
  SHOW_PROFILE_DIALOG, SWITCH_APPLICATION_LANGUAGE,
  UPDATE_ACCOUNT_EMAILS,
  UPDATE_ACCOUNT_USER, UPDATE_PERSON_CREDENTIAL_PASS_BY_ID
} from '@/store/action-types'
import {
  CURRENT_UI_LANGUAGE,
  SUPPORTED_LANGUAGES,
  USER_LOGGED_IN
} from '@/store/getter-types'
import {Component, Prop} from 'vue-property-decorator'
import {TranslateResult} from 'vue-i18n'
import i18n from '@/plugins/i18n'
import _ from 'lodash'
import { AccountEmail } from '@/model/AccountEmail'
import {ChangeNewPasswordPayload, UpdateAccountEmail, UserPayload} from '@/types/payload'
import {CurrentUser} from "@/model/CurrentUser";
import Language from "@/model/Language";
import DeleteDialog from "@/components/user/DeleteDialog.vue";

function valueIsRequired (v: string): boolean | TranslateResult {
  return !!v || i18n.t('validation.valueIsRequired')
}

function validateEmail (v: string): boolean | TranslateResult {
  if (v) {
    return /.+@.+\..+/.test(v) || i18n.t('validation.emailMustBeValid')
  }
  return true
}

function validatePhoneNumber (v: string): boolean | TranslateResult {
  if (v) {
    return  /^[+]?[\d\s]+$/.test(v) || i18n.t('validation.phoneNumberMustBeValid')
  }
  return true
}

function passwordLength(v: string): boolean | TranslateResult {
  if (v) {
    return v.length >= 4 || i18n.t('validation.passwordMinimumLength')
  }

  return false
}

@Component({
  components: {
    DeleteDialog,
  }
})
export default class ProfileDialog extends Vue {

  $refs!: {
    form: Vue & { validate: () => boolean }
  }

  private originalEmailList: AccountEmail[] = []
  private emailList: AccountEmail[] = []
  private passwordRules: Array<(v: string) => string | boolean | TranslateResult> = [
    (v: string) => !!v || i18n.t('validation.valueIsRequired'),
    (v: string) => !!v || i18n.t('validation.valueIsRequiredMessage'),
    (v: string) => {
      const pattern = /^[a-zA-Z0-9]*$/

      return pattern.test(v) || i18n.t('validation.valueIsRequiredMessage')
    },
  ]
  private emailRules = [
    valueIsRequired,
    validateEmail,
  ]
  private firstNameRules = [
    valueIsRequired,
  ]
  private familyNameRules = [
    valueIsRequired,
  ]
  private validatePhoneNumber = [
    validatePhoneNumber
  ]
  private isFormValid: boolean = false
  private isSaveInProgress: boolean = false
  private isLoading: boolean = false
  private showError: boolean = false
  private errorMessage: TranslateResult | null = null
  private firstName: string = ''
  private familyName: string = ''
  private phoneNumber: string = ''
  private loginName: string = ''
  private password: string | null = null
  private formIsValid: boolean = false
  private saveInProgress: boolean = false
  private snackbar: boolean = false
  private snackBarText: TranslateResult | null = null
  private snackbarColor: string = ''
  private tab: number = 0
  private selectedItem: Language | null = null
  private showDeleteDialog: boolean = false
  private value: string = 'unActive'
  private passwordChecked: boolean = false
  private showPassword: boolean = false


  @Action(SHOW_PROFILE_DIALOG) showProfileDialog!: { (payload: boolean): Promise<void> }
  @Action(FETCH_ACCOUNT_EMAILS) fetchAccountEmails!: ({ (): Promise<AccountEmail[]> })
  @Action(UPDATE_ACCOUNT_EMAILS) updateAccountEmails!: ({ (payload: UpdateAccountEmail[]): Promise<AccountEmail[]> })
  @Action(UPDATE_ACCOUNT_USER) updateAccountUser!: ({ (payload: UserPayload): Promise<void> })
  @Action(FETCH_ACCOUNT_USER) fetchAccountUser!: ({ (): Promise<void> })
  @Getter(USER_LOGGED_IN) currentUser!: CurrentUser
  @Getter(SUPPORTED_LANGUAGES) supportedLanguages!: Language[]
  @Getter(CURRENT_UI_LANGUAGE) currentLanguage!: Language
  @Action(UPDATE_PERSON_CREDENTIAL_PASS_BY_ID) updatePersonCredentialPassById!: { (payload: ChangeNewPasswordPayload): Promise<string> }
  @Action(SWITCH_APPLICATION_LANGUAGE) switchApplicationLanguage!: { (payload: Language): void }
  @Action(DELETE_CONFIRMATION) orderConfirmation!: ({ (payload: any): Promise<boolean> })
  @Action(SET_IS_DELETE_CONFIRMATION) setIsDeleteConfirmation!: ({ (payload: boolean): Promise<void> })
  @Action(DELETE_BOARDER) deleteBoarderAccount!: { (payload: any): Promise<any> }
  @Prop({type: Boolean, required: true}) show!: false

  get getTextFieldColor (): string {
    return this.passwordChecked ? 'checked' : ''

  }
  get passwordFieldIcon(): string {
    if(this.showPassword) {
      return 'fa-eye-slash'
    } else if(this.passwordChecked) {
      return 'fas fa-check'
    } else {
      return 'fa-eye'
    }

  }

  get passwordFieldType(): string {
    return this.showPassword ? 'text' : 'password'
  }

  get isInEditMode (): boolean {
    return !!this.emailList.find((item: AccountEmail) => item.isEdit)
  }

  get showSkeletonLoader (): boolean {
    return this.isLoading
  }

  generateCodeClick () {
    this.password = Math.floor(1000 + Math.random() * 9000).toString()
  }

  onLanguageSelect (language: Language): void {
      this.switchApplicationLanguage(language)
      localStorage.setItem('uiLanguageCodeApp', language.code)
  }

  onToggleShowPasswordClick(): void {
    this.showPassword = !this.showPassword
  }

  onAddButtonClick (): void {
    this.emailList.unshift(AccountEmail.createEmpty())
    this.originalEmailList.unshift(AccountEmail.createEmpty())
  }

  onSubmitCredentialsButtonClick () {
    this.updatePersonCredentialPassword()

  }

  onSubmitButtonClick (): void {
    this.isSaveInProgress = true
    this.save()
  }

  onCancelButtonClick (): void {
    this.closeDialog()
  }

  onCloseButtonClick (): void {
    this.closeDialog()
  }

  closeDialog (): void {
    this.showProfileDialog(false)
  }

  onExpansionClick () {
    setTimeout(() => {
      let card: any = document.querySelector("#card")
      let cardText: any = document.querySelector("#cardText")
      let options = {duration: 400, container: cardText}
      this.$vuetify.goTo(card, options)
    }, 0)
  }

  onEditClick (idx: number, item: AccountEmail): void {
    this.emailList.splice(idx, 1, item.update(!item.isEdit))
  }

  onDeleteClick (idx: number): void {
    this.emailList.splice(idx, 1)
    this.originalEmailList.splice(idx, 1)
  }

  onSaveChangesClick (idx: number, item: AccountEmail): void {
    this.$refs.form.validate()
    if(this.isFormValid && item.email) {
      this.emailList.splice(idx, 1, item.update(!item.isEdit))
      this.originalEmailList.splice(idx, 1, item.update(!item.isEdit))
    }
  }

  onCancelChangesClick (idx: number, item: AccountEmail): void {
    if(this.originalEmailList[idx].email) {
      this.emailList.splice(idx, 1, this.originalEmailList[idx])
    } else {
      this.emailList.splice(idx, 1)
      this.originalEmailList.splice(idx, 1)
    }
  }

  onDeleteLoginClick () {
    this.onLogUser()
  }

  closeDeleteDialogClick () {
    this.showDeleteDialog = false
    this.closeDialog()
    this.logUserOut()
  }

  async onLogUser(): Promise<void> {
    let response: boolean = false
    const payload: any = {
      username: this.currentUser.loginName,
      password: this.password
    }
    try{
      this.saveInProgress = true
      this.setIsDeleteConfirmation(true)
      response = await this.orderConfirmation(payload)

      this.saveInProgress = false
      this.setIsDeleteConfirmation(false)
      if (!response) {
        this.snackbarColor = "error"
        this.snackBarText = this.$t('errors.invalidCredentials').toString()
        this.snackbar = true
        this.password = ''

      } else {
        this.passwordChecked = true
      }
    } catch (e) {
      this.setIsDeleteConfirmation(false)
      this.snackbarColor = "error"
      this.snackBarText = this.$t('errors.invalidCredentials').toString()
      this.snackbar = true
    }
  }

  async logUserOut():Promise<void> {
    await this.$store.dispatch(AUTH_LOG_USER_OUT)
    this.$router.push('/login')
  }


  async fetchData (): Promise<void> {
    const data: AccountEmail[] = await this.fetchAccountEmails()
    this.originalEmailList = _.cloneDeep(data)
    this.emailList = _.cloneDeep(data)
    this.firstName = this.currentUser.givenName
    this.familyName = this.currentUser.familyName
    this.phoneNumber = this.currentUser.phoneNumbers[0]
    this.loginName = this.currentUser.loginName
    this.isLoading = false
  }

  async save(): Promise<void> {
    const payload: UpdateAccountEmail[] =  this.emailList.map((item: AccountEmail) => {
      return {email: item.email}
    })

    const userPayload: UserPayload = {
      firstName: this.firstName,
      familyName: this.familyName,
      phoneNumber: this.phoneNumber
    }

    try {
      await this.updateAccountUser(userPayload)
      this.emailList = await this.updateAccountEmails(payload)
      await this.fetchAccountUser()
    } catch (e) {
      this.errorMessage = this.$t('profileDialog.saveErrorMessage')
      this.showError = true
    } finally {
      this.isSaveInProgress = false
    }
  }

  async updatePersonCredentialPassword(): Promise<void>{
    const payload: ChangeNewPasswordPayload = {
      personId: this.currentUser.id,
      password: this.password!.toString(),
    }

    try {
      this.saveInProgress = true
      await this.updatePersonCredentialPassById(payload)
      this.snackbarColor = "success"
      this.snackBarText =this.$t('profileDialog.savedPassword')
      this.snackbar = true
    } catch (e) {
      this.snackbarColor = "error"
      this.snackBarText = this.$t('profileDialog.savePasswordErrorMessage')
      this.snackbar = true
    } finally {
      this.saveInProgress = false
    }
  }

  async deleteBoarder ():Promise<void> {
    const payload: any | null = this.currentUser.id
    this.saveInProgress = true
    try {
      const operationResult = await this.deleteBoarderAccount(payload)
      this.showDeleteDialog = true
      this.saveInProgress = false
    } catch (e) {
      this.snackbarColor = "error"
      this.snackBarText = this.$t('profileDialog.deleteErrorMessage').toString()
      this.snackbar = true

    } finally {
      this.saveInProgress = false
      this.passwordChecked = false

    }
  }

  mounted() {
    this.isLoading = true
    this.fetchData()
    this.selectedItem = this.currentLanguage
  }

}
